module.exports = __webpack_public_path__ + "static/media/RIGHTKOOS.065cb3b4.pdf";